<template lang="html">
 
 <div class="footer" v-if="isShow">
            <div class="content">
                <div class="items">
                    <ul>
                        <li>
                            <i class="icon icon-footer-1"></i>
                            <span>正品行货，品质保证</span>
                        </li>
                        <li>
                            <i class="icon icon-footer-2"></i>
                            <span>品类齐全，轻松购物</span>
                        </li>
                        <li>
                            <i class="icon icon-footer-3"></i>
                            <span>满99元免邮费</span>
                        </li>
                        <li>
                            <i class="icon icon-footer-4"></i>
                            <span>7天无忧退换货</span>
                        </li>
                    </ul>
                </div>
                <div class="links">
                    <ul>
                        <li v-for="(item, index) in bottomLinks" :key="'link_'+index">
                            <a @click="toDetail(item.id)">
                                {{item.title}}
                            </a>
                        </li>    
                        <li>
                            <a @click="toDetail(-1)">
                                用户反馈
                            </a>
                        </li>                      
                    </ul>
                </div>              
            </div>
            <div class="copyright">
                <div class="companyAddress">
                  福建省军缘科技有限公司 地址：福建省泉州市鲤城区开元街道顶埔108号D栋四楼 电话：0595—22192781
                </div>
                  <div class="content">               
                   <p v-if="filingsType==1">Copyright ©2023 <a href="https://beian.miit.gov.cn/" target="_blank">军缘-闽ICP备2023013448号-1</a></p>
                   <p v-if="filingsType==4">Copyright ©2023 <a href="https://beian.miit.gov.cn/" target="_blank">军缘-闽ICP备2023013448号-4</a></p>
                   <p v-if="filingsType==5">Copyright ©2023 <a href="https://beian.miit.gov.cn/" target="_blank">军缘-闽ICP备2023013448号-5</a></p>
                   <p v-if="filingsType==6">Copyright ©2023 <a href="https://beian.miit.gov.cn/" target="_blank">军缘-闽ICP备2023013448号-6</a></p>
                  </div>
            </div>
  </div>

</template>
<style>
@import '../../styles/footer.css';
</style>
<script>
import { getBottomLinks} from '@/api/bottomLink'
import { format } from 'url';
export default {
  name: 'footers',
  data() {
    return {
      adminLoginVisible: false,
      bottomLinks:[],
      isShow:true,
      filingsType:1
    }
  },
  computed: {
    date() {
      return new Date().getFullYear()
    }
  },
  created() {  
    var tempUrl = window.location.href.toUpperCase();    
    tempUrl = tempUrl.split('?')[0];
    if(tempUrl.indexOf('LOGINRESULT')!=-1)
    {
      this.isShow=false;
    }   
    if(tempUrl.indexOf('FJJYKJ.COM.CN')!=-1)
    {
       this.filingsType = 1;
    }
    if(tempUrl.indexOf('JUNYUANGO.COM')!=-1)
    {
       this.filingsType = 4;
    }
    if(tempUrl.indexOf('XUXINGTRIP.COM')!=-1)
    {
       this.filingsType = 5;
    }
    if(tempUrl.indexOf('LEHUILIFE.COM.CN')!=-1)
    {
       this.filingsType = 6;
    }
  },
  mounted () {
     this._getBottomLinks();
    },
  methods: {
    toDetail(tempId)
    {
      this.$router.push({path: '/bottomLink/Detail',query:{ id: tempId}})
    },

    async _getBottomLinks()
    {
       await getBottomLinks().then(res=>{
            this.bottomLinks =  res.data.result.items
        })
    }
  }
  
}
</script>



// WEBPACK FOOTER //
// index.vue?ca67bc2a